<template>
    <div>
        <fieldset>
            <legend>
                <v-chip
                    v-if="title"
                    :color="color ? color : 'teal'"
                    small
                    class="white--text ml-2 mr-2"
                >
                    <strong>{{ title }}</strong>
                </v-chip>
                <v-btn
                    v-if="showAddAction"
                    icon
                    :color="color ? color : 'teal'"
                    :disabled="readonly"
                    @click="add"
                >
                    <v-icon v-if="icon">{{ icon }}</v-icon>
                    <v-icon v-else>mdi-plus-circle-outline</v-icon>
                </v-btn>
            </legend>
            <v-container fluid>
                <slot></slot>
            </v-container>
        </fieldset>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        icon: String,
        color: String,
        showAddAction: Boolean,
        readonly: Boolean,
    },
    emits: ['add'],
    setup(props, {emit}) {
        function add() {
            emit('add');
        }

        return {
            add,
        }
    }
}
</script>

<style scoped>

</style>